import { render, staticRenderFns } from "./IdentifyView.vue?vue&type=template&id=fdb3dc6c&scoped=true&"
import script from "./IdentifyView.vue?vue&type=script&lang=js&"
export * from "./IdentifyView.vue?vue&type=script&lang=js&"
import style0 from "./IdentifyView.vue?vue&type=style&index=0&id=fdb3dc6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb3dc6c",
  null
  
)

/* custom blocks */
import block0 from "./IdentifyView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports